
import QRCode from 'qrcode';

// Client-side session cache.
// Stores the temporary Session Token returned by the server.
// Cleared on refresh.
let _sessionToken = '';

export const setSessionToken = (token: string) => {
    _sessionToken = token;
};

export const getSessionToken = () => _sessionToken;

export const hasSession = () => !!_sessionToken;

// Wrappers for Component use
export const generateQrCodeUrl = async (uri: string): Promise<string> => {
    // Generate QR on client to save server bandwidth.
    const fullUri = `otpauth://totp/SmartSeat:SuperAdmin?secret=${uri}&issuer=SmartSeat&algorithm=SHA1&digits=6&period=30`;
    return await QRCode.toDataURL(fullUri);
};
